import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-sage-50" data-id="element-68" data-mp="38n415zsrtsyv">
      <div className="max-w-5xl mx-auto" data-id="element-69" data-mp="3djawyzrgdo33">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-forest text-center mb-12 uppercase" data-id="element-70" data-mp="3dkcglsmjbiwf">
          Everything Included in <span className="text-leaf" data-id="element-71" data-mp="3mkiuvgq24mwn">Hydroponics Grower Ready</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-72" data-mp="3mifvw76xfjfs">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-forest border-b-4 border-leaf-bright rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-73" data-mp="11u0fwlkwh9us">
              <Icon size={28} className="text-lime-soft" aria-hidden="true" data-id="element-74" data-mp="1i7ge4ytcmg8r" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-75" data-mp="1dbix0qa9h5ux">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-76" data-mp="149i0xwqrkpuu">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-sage-200 rounded-xl p-4 flex items-center gap-3" data-id="element-77" data-mp="uk8bkonb1laf">
              <span className="w-9 h-9 rounded-lg bg-sage-100 text-leaf flex items-center justify-center shrink-0" data-id="element-78" data-mp="plom4e9i5rdb">
                <Icon size={18} aria-hidden="true" data-id="element-79" data-mp="kjz9iu6mt5n4" />
              </span>
              <span className="text-forest font-bold text-xs uppercase leading-tight" data-id="element-80" data-mp="gj5n658u7ywc">
                {label}
              </span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-leaf rounded-3xl p-8 md:p-12 shadow-xl shadow-forest/10 text-center" data-id="element-81" data-mp="1x8hp9sjbbe4">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-82" data-mp="3t4l1lwksy2xq" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-forest mb-3" data-id="element-83" data-mp="pmayygj9b283">
            HYDROPONICS GROWER <span className="text-leaf" data-id="element-84" data-mp="axn8goo9pip0">READY</span>
          </p>
          <p className="text-base text-charcoal/80 max-w-2xl mx-auto mb-8" data-id="element-85" data-mp="fwzsl1nr8bnw">
            A complete 6-in-1 visual hydroponics growing system designed to help you build your
            setup, understand your plants, manage the essential variables and grow fresh food from
            home with greater confidence.
          </p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-leaf mb-6" data-id="element-86" data-mp="2t2y5aysi02od">
            $27 USD
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-87" data-mp="2o4wd9od3gt0r">
            GET THE COMPLETE 6-IN-1 HYDROPONICS SYSTEM NOW
          </Button>
          <p className="text-xs text-charcoal/60 mb-10" data-id="element-88" data-mp="2a4vb85l3ffjp">
            Immediate Access · Complete 6-in-1 System · One-Time Payment
          </p>
          <div className="pt-8 border-t border-sage-200" data-id="element-89" data-mp="257v6pz3w6kup">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-forest mb-2 uppercase" data-id="element-90" data-mp="2j6l31ciw0gi0">
              Stop Guessing Your Way Through Hydroponics.
            </p>
            <p className="text-lg font-semibold text-leaf" data-id="element-91" data-mp="3ul89vl09q2u8">
              Build it. Control it. Grow it. Fix it. Harvest it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}